import React from 'react';
import PropTypes from 'prop-types';

const CustomPageDetailDescription = (props) => {
  return (
    <div className="m_liquidArea">
      {props.pageDescriptionHtml &&
      <div className="desc tui-editor-contents clearfix"
           dangerouslySetInnerHTML={{ __html: props.pageDescriptionHtml }}></div>
      }
    </div>
  );
};

CustomPageDetailDescription.propTypes = {
  pageDescriptionHtml: PropTypes.any,
};

export default CustomPageDetailDescription;
